// extracted by mini-css-extract-plugin
export default {"link":"CMx7rl","span":"FusJhL","icon":"ElEJAl"};